<template lang="pug">
    section#gastronomia
        .texto
            h1 {{ textBlock.titulo }}
            .content(v-html="textBlock.text")
        figure.chef
            Imagem(:content="chefBlock.image")
            figcaption {{ chefBlock.nome }}
        Imagem(:content="imageBlock.image").img
</template>

<script>
import { components } from '@/mixins/components'

export default {
    name: "component-gastronomia",
    components,
    props: {
        content: {
            type: Array,
            required: true
        },
    },
    computed: {
        textBlock() {
            return this.content.find(block => block.type == 'tituloTexto_item')
        },
        chefBlock() {
            return this.content.find(block => block.type == 'gastronomiaChef_item')
        },
        imageBlock() {
            return this.content.find(block => block.type == 'imagem_item')
        },
    },
}
</script>

<style lang="stylus" scoped src="./Gastronomia.styl"></style>